<template>
<div class="user-manage">
    <div class="top_handle_box">
        <div></div>
        <div>
            <div style="width: 150px;">
                <el-select v-model="userlevel" placeholder="用户类型" clearable>
                    <el-option v-for="item in userlevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="width: 200px;">
                <el-input v-model="customername" placeholder="请输入用户名称" clearable></el-input>
            </div>
            <div style="width: 200px;">
                <el-input v-model="mobileno" placeholder="请输入手机号码" clearable></el-input>
            </div>
            <el-button @click="handleSearch" type="primary" plain>搜索</el-button>
        </div>
    </div>
    <div class="btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="序号" width="60px" align="center" fixed>
                <template slot-scope="scope">{{(page - 1) * pagesize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="用户ID" width="120px" align="center" fixed>
                <template slot-scope="scope">
                    <div class="user-id" @click="handleOpenUser(scope.row)">{{scope.row.customerinnerid}}</div>
                </template>
            </el-table-column>
            <el-table-column label="姓名" width="120px" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.customername ? scope.row.customername : '--'}}</template>
            </el-table-column>
            <el-table-column label="手机号码" width="120px" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.mobileno ? scope.row.mobileno : '--'}}</template>
            </el-table-column>
            <el-table-column label="用户类型" width="120px" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.userlevelname}}</template>
            </el-table-column>
            <el-table-column label="过期时间" width="150px" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.userexpiredate ? scope.row.userexpiredate : '--'}}</template>
            </el-table-column>
            <el-table-column label="参与时间" width="150px" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.datetime ? scope.row.datetime : '--'}}</template>
            </el-table-column>
            <el-table-column label="最近时间" width="150px" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.lastlogintime ? scope.row.lastlogintime : '--'}}</template>
            </el-table-column>
            <el-table-column label="开通科目" min-width="150px" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.subjectnames ? scope.row.subjectnames : '--'}}</template>
            </el-table-column>
            <el-table-column label="操作" width="140px" align="right">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn">
                            <el-button @click.stop="handleOpenSubject(scope.row)" type="text" size="small">开通科目</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleTestSituation(scope.row)" type="text" size="small">做题情况</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="sizes, prev, pager, next" :total="total" :page-size="pagesize" :current-page="page" @size-change="handlePagesizeChange" @current-change="handlePageChange" :page-sizes="[10, 20, 50, 100]"></el-pagination>
    </div>
    <OpenedSubjectDialog ref="openedSubjectDialog"></OpenedSubjectDialog>
    <SpecialExamDialog ref="specialExamDialog"></SpecialExamDialog>
</div>
</template>
<script>
import {getQuestionbankuserinfoV2} from '@/api/questionApi.js'
import {mapActions} from 'vuex'
import OpenedSubjectDialog from './openedSubjectDialog.vue'
import SpecialExamDialog from '../specialExamDialog.vue'
export default {
    data() {
        return {
            init: false,
            page: 1,
            pagesize: 10,
            userlevel: '',
            userlevelList: [
                {label: '普通用户', value: 1},
                {label: '收费用户', value: 2}
            ],
            customername: '',
            mobileno: '',
            condition: {
                userlevel: '',
                customername: '',
                examcode: '',
                mobileno: '',
            },
            total: 0,
            tableData: []
        }
    },
    methods: {
        initData(params) {
            if (!this.init) {
                this.condition.examcode = params.examcode
                this.handleGetQuestionbankuserinfoV2()
            }
        },
        handleGetQuestionbankuserinfoV2() {
            this.setLoading(true)
            let params = {
                condition: JSON.parse(JSON.stringify(this.condition)),
                page: this.page,
                pagesize: this.pagesize
            }
            getQuestionbankuserinfoV2({
                data: params,
                success: data => {
                    this.setLoading(false)
                    this.total = data.pageableData.rowCount
                    this.tableData = data.data
                    this.init = true
                },
                error: error => {
                    this.setLoading(false)
                    this.$message.error(error.msg)
                }
            })
        },
        handleSearch() {
            this.page = 1
            this.condition.userlevel = this.userlevel
            this.condition.customername = this.customername
            this.condition.mobileno = this.mobileno
            this.handleGetQuestionbankuserinfoV2()
        },
        handlePagesizeChange(pagesize) {
            this.pagesize = pagesize
            this.page = 1
            this.handleGetQuestionbankuserinfoV2()
        },
        handlePageChange(page) {
            this.page = page
            this.handleGetQuestionbankuserinfoV2()
        },
        handleOpenSubject(row) {
            this.$refs.openedSubjectDialog.handleOpen(row)
        },
        handleTestSituation(row) {
            this.$refs.specialExamDialog.openDialog(row)
            // this.$router.push({
            //     name: 'MarkingDetails',
            //     query: {id: row.examid}
            // })
        },
        handleOpenUser(row) {

        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        OpenedSubjectDialog,
        SpecialExamDialog
    }
}
</script>
<style lang="scss">
.user-manage {
    .top_handle_box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        &>div:nth-of-type(2){
            display: flex;
            .el-input__icon {
                line-height: 0px;
            }
            &>div {
                margin-right: 20px;
            }
        }
    }
    .el-table {
        .user-id {
            color: #409EFF;
            cursor: pointer;
        }
    }
    .el-pagination {
        text-align: right;
        .el-pagination__sizes {
            .el-select {
                height: 28px;
                .el-input {
                    height: 28px;
                    .el-input__inner {
                        height: 28px;
                    }
                }
            }
        }
    }
}
</style>